module.exports = __webpack_public_path__ + "img/work_black.0150a8f1.png";